defineGlobalOnce('ThemeSection_EventsFromPage', (requestURL) => {
  return {
    init() {
      fetch(requestURL)
        .then((res) => res.text())
        .then((data) => {
          let sectionData;
          if (requestURL.indexOf('?sections=') > -1) {
            const sectionID = requestURL.split('?sections=').pop();
            const jsonData = JSON.parse(data);
            sectionData = jsonData[sectionID];
          } else {
            sectionData = data;
          }
          const newDOM = new DOMParser().parseFromString(
            sectionData,
            'text/html',
          );
          const eventsList = newDOM.querySelector('.events');
          if (eventsList) {
            this.$el.replaceChildren(eventsList);
          } else {
            console.warn('Could not find .events list in fetched data');
            // Optional: Clear the container or show a message
            this.$el.innerHTML = '<p>Could not load events.</p>'; 
          }
        })
        .catch(function (error) {
          console.warn('error fetching events data:', error);
        });
    },
  };
});
